// extracted by mini-css-extract-plugin
module.exports = {"mainComponent":"style_mainComponent__2GbDs","button":"style_button__ejwnd"};